var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container studio-community-container mt-5 pb-3 pt-3"},[_c('HMCustomContent',{attrs:{"json":_vm.description}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }